<template>
    <div :class="view_class_view.div_container">
        <div>
            <label for="input_height">Estatura (mts):</label>
            <input type="text" id="input_height" 
                v-maska="'#.##'"
                v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: personMeasuresModelValidations.height.$error,
                [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!personMeasuresModelValidations.height.$invalid,
                [view_class_view.class_inputs.default ]: personMeasuresModelValidations.height.$invalid && !personMeasuresModelValidations.height.$error  }"
                v-model="personMeasuresModel.height"
                @blur="personMeasuresModelValidations.height.$validate">
            <div :class="view_class_view.div_container_error.container" v-for="(error,index) of personMeasuresModelValidations.height.$errors" :key="index">
                <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
            </div> 
        </div>
        <div>
            <label for="input_weight">Peso (kg):</label>
            <input type="text" id="input_weight"
                v-maska="'###'"
                v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: personMeasuresModelValidations.weight.$error,
                [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!personMeasuresModelValidations.weight.$invalid,
                [view_class_view.class_inputs.default ]: personMeasuresModelValidations.weight.$invalid && !personMeasuresModelValidations.weight.$error  }"
                v-model="personMeasuresModel.weight"
                @blur="personMeasuresModelValidations.weight.$validate">

            <div :class="view_class_view.div_container_error.container" v-for="(error,index) of personMeasuresModelValidations.weight.$errors" :key="index">
                <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
            </div> 
        </div>
    </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { ref } from 'vue';

export default {
    name: 'QuotationHeightAndWeightComponent',
    props:{
        validations:{
            type: Object,
            default(){
                return {};
            }
        },
        view_class_view:{
            type: Object,
            default(){
                return {};
            }
        }
    },
    setup(props){
        let personMeasuresModel = ref({
            height: "",
            weight: ""
        });

        let personMeasuresModelValidations = useVuelidate(props.validations, personMeasuresModel);

        function execute_validation() {
            this.personMeasuresModelValidations.$validate();
            if(this.personMeasuresModelValidations.$error){
                return false;
            }
            return personMeasuresModel.value;
        }

        return {
            personMeasuresModel,
            personMeasuresModelValidations,
            execute_validation
        };
    }
}
</script>